function resizeTextAd(iframe) {    
    let textDriver = document.getElementById('textDriverRespnsve');
    
    // allow ad be responsive
    iframe.style.width = '100%';
    
    if (typeof textDriver !== 'undefined') {
        iframe.style.height = textDriver.clientHeight + 'px';
    }

    // remove constricting dimensions on iframe parent (sometimes set as 2x3)
    iframe.parentElement.style.width = '';
    iframe.parentElement.style.height = '';
}

if (window.parent) {
    if (
        window.parent.profads &&
        window.parent.profads.ads2 &&
        window.parent.profads.ads2.ResizeTextAds
    ) {
        window.parent.profads.ads2.ResizeTextAds();
    } else {
        if (window.parent.ibAds && typeof window.frameElement !== 'undefined') {
            // not dependent on window.parent.ibAds namespace at this time,
            // but function 'resizeTextAd' may be moved to namespace
            // if universally supported on all affiliates
            resizeTextAd(window.frameElement);
            window.addEventListener('resize', function() {
                resizeTextAd(window.frameElement);
            }, false);
        }
    }
}
